import type { AppDefinition } from '../../types/apps';

export const APIConnectionAppDefinition: AppDefinition = {
  appId: 'api-connections',
  name: 'API Connections',
  version: '1.0.0',
  description: 'Manage API connections and integrate external services',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'Plugs',
    phosphorWeight: 'duotone',
    color: '#0ea5e9',
  },
  supportedFileTypes: [],
  entityTypes: ['APIConnection'],
  component: 'api-connections',
  requiresProps: false,
  requiresEntity: false,
  actions: {}
};
